import { storage } from './Storage';

export default storage.get('auth');
